<template>
  <div class="mobile-nav">
    <scrollactive :offset="80" :modify-url="false" :class="{ 'menu-open': open }" class="menu">
      <v-list dense tag="nav">
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          :href="item.href"
          :class="item.href ? 'scrollactive-item' : undefined"
          @click="
            if (!item.href && item.to) $router.push(item.to);
            $emit('close');
          "
          link
          :style="{ animationDuration: index * 0.2 + 's' }"
        >
          <v-list-item-content>
            <v-list-item-title class="menu-list">{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item
          :href="link.saas.contact"
          :style="{ animationDuration: navMenu.length * 0.15 + 's' }"
          link
        >
          <v-list-item-content>
            <v-list-item-title class="menu-list"><span v-t="'Contact'" /></v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-divider class="divider-sidebar" />
        <div v-if="$store.state.auth">
          <v-list-item
            id="hamburger-logout"
            href="#log-out"
            key="logout"
            @click.prevent="logOut"
            :style="{
              animationDuration: (menuItems.length + 1) * 0.2 + 's',
            }"
            link
          >
            <v-list-item-content>
              <v-list-item-title class="menu-list"><span v-t="'Sign out'" /></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div v-else>
          <v-list-item
            :id="`hamburger-${item}`"
            v-for="(item, i) in ['login', 'register']"
            :key="item"
            :to="link.saas[item]"
            :style="{
              animationDuration: (navMenu.length + 1 + i) * 0.15 + 's',
            }"
            link
          >
            <v-list-item-content>
              <v-list-item-title class="menu-list">
                {{ $t(item) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <AppLanguageSelector class="mt-5" :icon="false">
        <template #default="{ name }">
          <span class="ml-3 white--text font-weight-light">{{ name }}</span>
        </template>
      </AppLanguageSelector>
    </scrollactive>
  </div>
</template>

<style scoped lang="scss">
@import "./header-style";
</style>

<script>
import AppLanguageSelector from "../app-language/AppLanguageSelector";
import navMenu from "./menu";
import link from "@/landing/static/text/link";
import logoutMixin from "@/landing/mixins/logoutMixin";

export default {
  components: {
    AppLanguageSelector,
  },
  mixins: [logoutMixin],
  data() {
    return {
      link: link,
      navMenu: navMenu,
    };
  },
  computed: {
    menuItems() {
      const items = [
        {
          title: "Home",
          to: { name: "welcome" },
          href: this.$route.name === "welcome" ? "/#home" : undefined,
          to:
            this.$route.name === "welcome"
              ? undefined
              : { name: "welcome"},
        },
        {
          title: "Features",
          href: this.$route.name === "welcome" ? "/#features" : undefined,
          to:
            this.$route.name === "welcome"
              ? undefined
              : { name: "welcome", query: { anchor: "features" } },
        },
        {
          title: "Pricing",
          href: this.$route.name === "welcome" ? "#pricing" : undefined,
          to:
            this.$route.name === "welcome"
              ? undefined
              : { name: "welcome", query: { anchor: "pricing" } },
        },
      ];

      if (this.$store.state.auth) {
        items.push({ title: "My Businesses", to: { name: "home", query: { tab: "businesses" } } });
        items.push({ title: "My Account", to: { name: "home", query: { tab: "account" } } });
      }
      return items;
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
